module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_116-f3.f231cb1c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_116-f3.png
// module id = 1052
// module chunks = 16